import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { HOST } from "Constant/Constant";

export const userRoleApi = createApi({
    reducerPath: "userRoleApi",
    baseQuery: fetchBaseQuery({
        baseUrl: HOST,
    }),
    endpoints: (builder) => ({
        getRolePermissions: builder.mutation({
            query: () => ({
                url: "/get-role-permissions",
                method: "GET",
                headers: {
                    authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            }),
        }),
        updateRolePermissions: builder.mutation({
            query: (body) => ({
                url: "/update-role-permissions",
                method: "POST",
                headers: {
                    authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                body,
            }),
        }),
    }),
});

export const { useGetRolePermissionsMutation, useUpdateRolePermissionsMutation } = userRoleApi;
